import module from 'kendu/legacy/module'
import { element } from 'angular'
import { forEach } from 'lodash'

function $fileSystem ($q, $log, $window) {
  this.select = select
  this.create = create

  function select (multiple, accept) {
    return $q((resolve, reject) => {
      let uploader = element('<input type="file">')

      uploader.attr('multiple', multiple === true)
      uploader.attr('accept', accept || '')

      uploader.on('change', function (event) {
        try {
          let files = []
          forEach(event.target.files, (file) => {
            if (file.type === '' || accept.split(',').some((test) => new RegExp(test.trim()).test(file.type))) {
              files.push(file)
            } else {
              throw new Error('Invalid file type ' + file.type)
            }
          })
          resolve(files)
        } catch (e) {
          $log.error(e)
          reject(e)
        }
      })

      uploader[0].click()
    })
  }

  function create (data, content) {
    let name = data.name
    let type = data.type
    let lastModified = data.lastModified || (data.lastModifiedDate ? data.lastModifiedDate.getTime() : undefined)
    let lastModifiedDate = data.lastModifiedDate || (data.lastModified ? new Date(data.lastModified) : undefined)

    return new $window.File(content || [], name, {
      lastModified: lastModified,
      lastModifiedDate: lastModifiedDate,
      type: type,
    })
  }
}

module.service('$fileSystem', $fileSystem)



// WEBPACK FOOTER //
// ./src/deprecated/services/$fileSystem.js